import { Pipe, PipeTransform } from '@angular/core';

import { BuiltLocalRoom } from '@models/commutiny-chat/built-local-room.model';

@Pipe({ name: 'appEdited' })
export class EditedPipe implements PipeTransform {
  transform(current: string, old: string | undefined): boolean {
    return current !== old;
  }
}
